<script setup lang="ts">
import {Model} from "@/app/Model";
import {onMounted, ref} from "vue";
import {Comms, type IEsito} from "@/app/Comms";
import Choices from "choices.js";

let model: Model = Model.getReactiveInstance();
let comms: Comms = Comms.getInstance();

let choices1a: Choices | null = null;
let choices1b: Choices | null = null;
let choices2a: Choices | null = null;

onMounted(() => {
  checkStart();
});
function checkStart(): void {
  if (!Model.pen_setupped) {
    setTimeout(() => checkStart(), 100)
  } else if (!Comms.listAllDone) {
    Comms.getInstance().listAll(() => {
      checkStart();
    });
  } else {
    comms.penaleAdmin.listCapo_imputazione_legge_rubrica((e: IEsito) => {
      initComponents();
    })
  }
}

function initChoices(): void {
  if (choices1a) choices1a.destroy();
  let choiceItems: any[] = [{
    value: "",
    label: "Scegli...",
    selected: true,
    disabled: false
  }];
  model.lista_capo_imputazione_legge.forEach(x => choiceItems.push(
      {
        value: x.capo_imputazione_legge,
        label: x.capo_imputazione_legge + ((x.rubrica && x.rubrica != "" && x.rubrica !== x.capo_imputazione_legge)? " | "+ x.rubrica:"") + (x.tot? " <small>["+x.tot+"]</small>":""),
        selected: false,
        disabled: false
      }
  ));
  let itemItems: any[] = [{
    value: "",
    label: "Scegli...",
    selected: true,
    disabled: false
  }]
  //@ts-ignore
  choices1a = new Choices(document.getElementById('input_massiveReplaceCapoImputazione_value'), {
    items: itemItems,
    choices: choiceItems,
    allowHTML: true,
    placeholder: false,
    loadingText: 'Caricamento...',
    noResultsText: 'Nessun risultato',
    noChoicesText: 'Nessun elemento da selezionare',
    itemSelectText: 'Premi per selezionare',
    shouldSort: false
  });

  if (choices1b) choices1b.destroy();
  let choiceItems1b: any[] = [{
    value: "",
    label: "Scegli...",
    selected: true,
    disabled: false
  }];
  model.lista_capo_imputazione_legge_rubrica.forEach(x => choiceItems1b.push(
      {
        value: x.capo_imputazione_legge,
        label: x.capo_imputazione_legge + ((x.rubrica && x.rubrica != "" && x.rubrica !== x.capo_imputazione_legge)? " | "+ x.rubrica:"") + (x.tot? " <small>["+x.tot+"]</small>":""),
        selected: false,
        disabled: false
      }
  ));
  let itemItems1b: any[] = [{
    value: "",
    label: "Scegli...",
    selected: true,
    disabled: false
  }]
  //@ts-ignore
  choices1b = new Choices(document.getElementById('input_massiveReplaceCapoImputazione_to'), {
    items: itemItems1b,
    choices: choiceItems1b,
    allowHTML: true,
    placeholder: false,
    loadingText: 'Caricamento...',
    noResultsText: 'Nessun risultato',
    noChoicesText: 'Nessun elemento da selezionare',
    itemSelectText: 'Premi per selezionare',
    shouldSort: false
  });

  //---
  if (choices2a) choices2a.destroy();
  let choiceItems2a: any[] = [{
    value: "",
    label: "Scegli...",
    selected: true,
    disabled: false
  }];
  model.lista_capo_imputazione_legge.forEach(x => choiceItems2a.push(
      {
        value: x.capo_imputazione_legge,
        label: x.capo_imputazione_legge + ((x.rubrica && x.rubrica != "" && x.rubrica !== x.capo_imputazione_legge)? " | "+ x.rubrica:"") + (x.tot? " <small>["+x.tot+"]</small>":""),
        selected: false,
        disabled: false
      }
  ));
  let itemItems2a: any[] = [{
    value: "",
    label: "Scegli...",
    selected: true,
    disabled: false
  }]
  //@ts-ignore
  choices2a = new Choices(document.getElementById('input_massiveDeleteCapoImputazione_value'), {
    items: itemItems2a,
    choices: choiceItems2a,
    allowHTML: true,
    placeholder: false,
    loadingText: 'Caricamento...',
    noResultsText: 'Nessun risultato',
    noChoicesText: 'Nessun elemento da selezionare',
    itemSelectText: 'Premi per selezionare',
    shouldSort: false
  });

}
//COMPONENTS
function initComponents(): void {
  initChoices();
}

function updateComponents(): void {
  //console.log("Update components", model.pen_flow_percorso, model.pen_get_percorso)
  initChoices();
  if (choices1a) choices1a.setChoiceByValue(model.pen_admin.massiveReplaceCapoImputazione_value);
  if (choices1b) choices1b.setChoiceByValue(model.pen_admin.massiveReplaceCapoImputazione_to);
  if (choices2a) choices2a.setChoiceByValue(model.pen_admin.massiveDeleteCapoImputazione_value);
}

//-----------------------
//business
function callQueryMassiveDelete(): void {
  if (confirm("Attenzione! L'eliminazione ha impatto su tutte le sentenze del perimetro, e non è reversibile.\nSei sicuro di voler contrinuare?")) {
    Comms.getInstance().penaleAdmin.chiamataMassiveDelete((e: IEsito) => {
      updateAfterCallDelete(e);
    });
  }
}
function callQueryMassiveReplace(): void {
  if (confirm("Attenzione! La modifica ha impatto su tutte le sentenze del perimetro, e non è reversibile.\nSei sicuro di voler contrinuare?")) {
    Comms.getInstance().penaleAdmin.chiamataMassiveReplace((e: IEsito) => {
      updateAfterCallUpdate(e);
    });
  }
}
function updateAfterCallDelete(e: IEsito): void {
  if (e.isOk) {
    comms.listCapo_imputazione_legge((e: IEsito) => {
      cleanMassiveDelete();
    })
    alert("ELIMINAZIONE MASSIVA ESEGUITA CON SUCCESSO!");
  } else {
    alert("ERRORE NELLA ELIMINAZIONE MASSIVA\n"+ e.response.data.msPenaleMassiveUpdate.message);
  }
}

function updateAfterCallUpdate(e: IEsito): void {
  if (e.isOk) {
    comms.listCapo_imputazione_legge((e: IEsito) => {
      comms.penaleAdmin.listCapo_imputazione_legge_rubrica((e: IEsito) => {
        cleanMassiveUpdate();
      })
    })
    alert("MODIFICA MASSIVA ESEGUITA CON SUCCESSO!");
  } else {
    alert("ERRORE NELLA MODIFICA MASSIVA\n"+ e.response.data.msPenaleMassiveUpdate.message);
  }
}

function cleanMassiveUpdate(): void {
  model.pen_admin.massiveReplaceCapoImputazione_value = "";
  model.pen_admin.massiveReplaceCapoImputazione_to = "";
  updateComponents();
}
function cleanMassiveDelete(): void {
  model.pen_admin.massiveDeleteCapoImputazione_value = "";
  updateComponents();
}
</script>

<template>
  <div class="row adminMassive">
    <div class="col-12 col-lg-7">
      <h3>Modifica Massiva Capo Imputazione</h3>

      <div class="row">
        <div class="col-4">
          <label for="input_massiveReplaceCapoImputazione_value">Originale</label>
          <select class="form-select js-choice" id="input_massiveReplaceCapoImputazione_value" v-model="model.pen_admin.massiveReplaceCapoImputazione_value"></select>
        </div>
        <div class="col-4">
          <label for="input_massiveReplaceCapoImputazione_to">Sostituto</label>
          <select class="form-select js-choice" id="input_massiveReplaceCapoImputazione_to" v-model="model.pen_admin.massiveReplaceCapoImputazione_to"></select>
        </div>
        <div class="col-4">
          <div>&nbsp;</div>
          <button type="button" class="btn btn-sm btn-error" @click="callQueryMassiveReplace()" v-if="model.pen_admin.massiveReplaceCapoImputazione_value != '' && model.pen_admin.massiveReplaceCapoImputazione_to != ''">Esegui</button>
          <button type="button" class="btn btn-sm btn-primary" @click="cleanMassiveUpdate()" v-if="model.pen_admin.massiveReplaceCapoImputazione_value != '' || model.pen_admin.massiveReplaceCapoImputazione_to != ''">Pulisci</button>
        </div>
      </div>
    </div>

    <div class="col-12 col-lg-5">
      <h3>Eliminazione Massiva Capo Imputazione</h3>
      <div class="row">
        <div class="col-8">
          <label for="input_massiveDeleteCapoImputazione_value">Originale</label>
          <select class="form-select js-choice" id="input_massiveDeleteCapoImputazione_value" v-model="model.pen_admin.massiveDeleteCapoImputazione_value"></select>
        </div>
        <div class="col-4">
          <div>&nbsp;</div>
          <button type="button" class="btn btn-sm btn-error" @click="callQueryMassiveDelete()" v-if="model.pen_admin.massiveDeleteCapoImputazione_value != ''">Esegui</button>
          <button type="button" class="btn btn-sm btn-primary" @click="cleanMassiveDelete()" v-if="model.pen_admin.massiveDeleteCapoImputazione_value != ''">Pulisci</button>
        </div>
      </div>
    </div>
  </div>
</template>